import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { CompanyOffice } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyOfficeService } from 'src/app/services/company-office.service';
import { GridService } from 'src/app/services/grid.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-company-offices-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './company-offices-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CompanyOfficesGridComponent extends BaseGridComponent {
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private CompanyOfficeService: CompanyOfficeService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'CompanyOffice';
    this.rowModelType = 'serverSide';
    this.suppressFieldDotNotation = false;

    this.additionalQueryData = {
      attributes: ['id']
    };

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.CompanyOfficeService.getCompanyOffices(queryObject),
          this.CompanyOfficeService.getCompanyOfficeCount(countQueryObject)
        ]).subscribe({
          next: ([CompanyOffices, companyOfficeCount]) => {
            const successObject: { rowData: any[]; rowCount: number } = {
              rowData: CompanyOffices,
              rowCount: companyOfficeCount
            };

            params.success(successObject);
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
